import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, renderIcon } from '@ecdlink/ui';
import { createContext, useContext, useEffect, useState } from 'react';
const Snackbar = ({ message, duration, type, onClose, }) => {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        if (!visible) {
            onClose();
        }
    }, [visible, onClose]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
        }, duration);
        return () => clearTimeout(timer);
    }, [duration]);
    const handleClose = () => {
        setVisible(false);
    };
    return (_jsx("div", Object.assign({ className: `fixed bottom-4 left-1/2 z-50 w-11/12 -translate-x-1/2 transform rounded-md transition-opacity ${visible ? 'opacity-100' : 'pointer-events-none opacity-0'}` }, { children: _jsx(Alert, { type: type, title: message, variant: "outlined", button: _jsx("button", Object.assign({ onClick: handleClose, className: "absolute top-0 bottom-0 right-4 my-0" }, { children: renderIcon('XIcon', `${type === 'success' ? 'text-white' : 'text-gray-900'} h-6 w-6`) })) }) })));
};
const SnackbarContext = createContext(undefined);
export const SnackbarProvider = ({ children }) => {
    const [message, setMessage] = useState('');
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(5000);
    const [snackbarType, setSnackbarType] = useState('success');
    const showMessage = ({ message, duration, type }) => {
        setMessage(message);
        setIsSnackbarOpen(true);
        if (type) {
            setSnackbarType(type);
        }
        if (duration) {
            setSnackbarDuration(duration);
        }
        else {
            setSnackbarDuration(5000);
        }
    };
    const closeSnackbar = () => {
        setIsSnackbarOpen(false);
    };
    return (_jsxs(SnackbarContext.Provider, Object.assign({ value: { showMessage } }, { children: [children, isSnackbarOpen && (_jsx(Snackbar, { message: message, duration: snackbarDuration, onClose: closeSnackbar, type: snackbarType }))] })));
};
export const useSnackbar = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
};
//# sourceMappingURL=index.js.map